import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import Button from "@components/base/Button/Button";

window.__hideCrispLauncher = true;

const ButtonChat = () => {
	const isChatOpenRef = useRef(false);
	const [chatButtonLayout, setChatButtonLayout] = useState('chatWhiteBorder');
	const [isCrispReady, setIsCrispReady] = useState(
	  () => typeof document !== 'undefined' && !!document.getElementById('crisp-chatbox')
	);
	const [isCrispLauncherActive, setIsCrispLauncherActive] = useState(true);

	// Hide Crisp before paint (synchronously). The style and __hideCrispLauncher
	// flag are intentionally NOT cleaned up on unmount — otherwise the native
	// Crisp launcher would flash during SPA route changes.
	useLayoutEffect(() => {
		if (document.getElementById('crisp-custom-style')) {
			return;
		}

		const style = document.createElement('style');
		style.id = 'crisp-custom-style';
		style.textContent = `
			#crisp-chatbox[data-mobile-view="false"] [aria-label="Затвори чата"],
			#crisp-chatbox[data-mobile-view="false"] [aria-label="Close chat"],
			#crisp-chatbox[data-mobile-view="false"] [data-is-failure][role="button"][data-maximized] {
				display: none !important;
				visibility: hidden !important;
				opacity: 0 !important;
				pointer-events: none !important;
			}
		`;
		document.head.appendChild(style);
	}, []);

	// Crisp API logic (asynchronously)
	useEffect(() => {
		const refreshLauncherVisibility = () => {
			try {
				const visible = window.$crisp.is("chat:visible");
				const available = window.$crisp.is("website:available");
				setIsCrispLauncherActive(Boolean(visible !== false && available !== false));
			} catch {
				setIsCrispLauncherActive(true);
			}
		};

		const setupCrispListeners = () => {
			window.$crisp.push(["do", "chat:close"]);
			window.$crisp.push(["do", "chat:hide"]);
			isChatOpenRef.current = false;
			setChatButtonLayout('chatWhiteBorder');

			window.$crisp.push(["on", "chat:closed", () => {
				window.$crisp.push(["do", "chat:hide"]);
				isChatOpenRef.current = false;
				setChatButtonLayout('chatWhiteBorder');
			}]);

			window.$crisp.push(["on", "chat:opened", () => {
				isChatOpenRef.current = true;
				setChatButtonLayout('closeWhiteBorder');
			}]);

			window.$crisp.push(["on", "website:availability:changed", refreshLauncherVisibility]);

			refreshLauncherVisibility();
			setIsCrispReady(true);
		};

		const originalTrigger = window.CRISP_READY_TRIGGER;

		window.CRISP_READY_TRIGGER = () => {
			if (typeof originalTrigger === 'function') {
				originalTrigger();
			}
			setupCrispListeners();
		};

		if (document.getElementById('crisp-chatbox')) {
			setupCrispListeners();
		}

		return () => {
			if (window.$crisp) {
				window.$crisp.push(["off", "chat:closed"]);
				window.$crisp.push(["off", "chat:opened"]);
				window.$crisp.push(["off", "website:availability:changed"]);
			}
		};
	}, []);

	const toggleChat = () => {
		if (window.$crisp) {
			if (isChatOpenRef.current) {
				window.$crisp.push(["do", "chat:close"]);
				window.$crisp.push(["do", "chat:hide"]);
				isChatOpenRef.current = false;
				setChatButtonLayout('chatWhiteBorder');
			} else {
				window.$crisp.push(["do", "chat:show"]);
				window.$crisp.push(["do", "chat:open"]);
				isChatOpenRef.current = true;
				setChatButtonLayout('closeWhiteBorder');
			}
		}
	};

	if (!isCrispReady || !isCrispLauncherActive) {
		return null;
	}

	return <Button layout={chatButtonLayout} onClick={toggleChat}/>;
};

export default ButtonChat;